import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const MagicLinkForm = ({ onSubmit, isLoading, success, error }) => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const handleEmailChange = (e) => {
    setEmail(e?.target?.value);
    if (emailError) {
      setEmailError('');
    }
  };

  const validateEmail = () => {
    if (!email) {
      setEmailError('Email is required');
      return false;
    }
    if (!/\S+@\S+\.\S+/?.test(email)) {
      setEmailError('Please enter a valid email address');
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (validateEmail()) {
      onSubmit(email);
    }
  };

  if (success) {
    return (
      <div className="text-center space-y-4">
        <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto">
          <Icon name="Mail" size={32} className="text-success" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-text-primary mb-2">Check Your Email</h3>
          <p className="text-sm text-text-secondary">
            We've sent a magic link to <strong>{email}</strong>. 
            Click the link in your email to sign in instantly.
          </p>
        </div>
        <div className="p-3 bg-muted rounded-md">
          <p className="text-xs text-text-secondary">
            Didn't receive the email? Check your spam folder or try again in a few minutes.
          </p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="text-center mb-6">
        <h3 className="text-lg font-semibold text-text-primary mb-2">Magic Link Sign In</h3>
        <p className="text-sm text-text-secondary">
          Enter your email and we'll send you a secure link to sign in instantly.
        </p>
      </div>

      <Input
        label="Email Address"
        type="email"
        value={email}
        onChange={handleEmailChange}
        placeholder="Enter your email address"
        error={emailError}
        required
        disabled={isLoading}
        className="w-full"
      />

      {error && (
        <div className="p-3 bg-error/10 border border-error/20 rounded-md">
          <div className="flex items-center space-x-2">
            <Icon name="AlertCircle" size={16} className="text-error" />
            <p className="text-sm text-error">{error}</p>
          </div>
        </div>
      )}

      <Button
        type="submit"
        variant="default"
        size="lg"
        loading={isLoading}
        disabled={isLoading}
        fullWidth
        iconName="Send"
        iconPosition="left"
      >
        {isLoading ? 'Sending Magic Link...' : 'Send Magic Link'}
      </Button>
    </form>
  );
};

export default MagicLinkForm;